import {Log} from './../utils/utils';
import {apiMain} from './apis/apiMain';
import {Ecolors, urlApp} from 'constant';

export interface AdministrativeUnit {
  id: number | string;
  administrativeCode: string;
  name?: string;
  [key: string]: any; // Dành cho các trường bổ sung từ API
}
export interface UserAddress {
  permanentAddress: string;
  countryId: number;
  provinceId: number | string;
  districtId: number | string;
  wardId: number | string;
  mailingAddress: string;
  mailingCountryId: number;
  mailingProvinceId: number | string;
  mailingDistrictId: number | string;
  mailingWardId: number | string;
  country: any; // Object country từ API
  province: AdministrativeUnit | undefined;
  district: AdministrativeUnit | undefined;
  ward: AdministrativeUnit | undefined;
}

export interface UserProfile {
  nationalityId: number;
  idTypeId: number;
  dateOfIssue: string;
  placeOfIssue: string;
  gender: number; // 1: MALE, 0: OTHERS/FEMALE
  dob: any; // Dữ liệu ngày sinh từ ekycResult
  idNo: any; // Số CMND/CCCD
  name: any; // Họ tên
}

export interface CCCDConversionResult {
  userAddress: UserAddress;
  userProfile: UserProfile;
  isKYC: boolean;
  rawImage: any; // Hình ảnh gốc từ result
  rule_table: any; // Bảng rule từ ekycResult
  decision: {
    code: number;
  };
}

export const configEkyc = {
  domain: `${urlApp.APIURL}api`,
  configEndpoint: {
    front: '/ekyc/v1.2/id/verify/front',
    back: '/ekyc/v1.2/id/verify/back',
    selfie: '/ekyc/v1.2/selfie/verify',
    complete: '/ekyc/v1.2/complete',
    nfcqrverify: '/ekyc/v2.0/nfcqr/verify',
    nfcrar: '/ekyc/v1.2/nfcqr/upload',
    ocr: '/ekyc/v1.2/id/ocr',
    nfcbshield: '/ekyc/v1.2/nfcqr/upload',
    createrequest: '/ekyc/v1.2/request/create',
    accesstoken: '',
  },
  stepVerification: ['FRONT', 'BACK', 'SELFIE', 'EDITOCR'],
  titleColor: Ecolors.textColor, //80%
  subTitleColor: Ecolors.grayColor, //60%
  closeColor: Ecolors.textColor, //80%
  buttonCaptureColor: Ecolors.mainColor,
  titleButtonCaptureColor: '#ffffff',
  backgroundColor: '#ffffff',
  requestId: '',
  clientId: 'ea8df9ebff8d38479058d7f1d235e097',
  clientSecret: '+xzqA0O4GScV2dSiaB2cDiYVDY7hE0pG6rqN0TTNbU4=',
  accessToken: '',
  configHeader: '',
};

export const convertDaTaCCCD = async (
  result: any,
): Promise<CCCDConversionResult> => {
  const {idInfo} = result;
  const gender = idInfo?.gender?.value === 'MALE' ? 1 : 0;

  Log('trueid result>', result);

  const {
    idInfo: {
      id_address_province,
      id_address_district,
      id_address_ward,
      id_address,
    },
    rawImage,
    ekycResult: {
      kyc_result: {
        back: {given_date, given_place},
        complete: {dob, full_name, id_number},
        rule_table,
      },
    },
    decision,
  } = result;

  const listCountry = await apiMain.getCountry();
  const country = listCountry.data.find((a: any) => a?.id == '234');
  const listProvince = await apiMain.getProvince({
    countryId: 234,
  });
  const province = listProvince.data.find((a: any) =>
    a.administrativeCode == id_address_province?.code
      ? id_address_province?.code
      : 0,
  );
  const listDistrict = await apiMain.getDistrict({
    provinceId: province?.id || 0,
  });
  const district = listDistrict.data.find((a: any) =>
    a.administrativeCode == id_address_district?.code
      ? id_address_district?.code
      : 0,
  );
  const listWard = await apiMain.getWard({
    districtId: district?.id || 0,
  });
  const ward = listWard.data.find((a: any) =>
    a.administrativeCode == id_address_ward?.code ? id_address_ward?.code : 0,
  );

  const isKYC =
    decision?.code == 1 ||
    (decision?.code != 1 && rule_table?.[1]?.rules?.[4]?.check_result == 2) ||
    (decision?.code != 1 && rule_table?.[1]?.rules?.[5]?.check_result == 2);

  const userAddress = {
    permanentAddress: id_address?.value || '',
    countryId: 234,
    provinceId: province?.id || 0,
    districtId: district?.id || 0,
    wardId: ward?.id || 0,
    //
    mailingAddress: id_address?.value,
    mailingCountryId: 234,
    mailingProvinceId: province?.id || 0,
    mailingDistrictId: district?.id || 0,
    mailingWardId: ward?.id || 0,
    //
    country,
    province,
    district,
    ward,
    //
  };
  const userProfile = {
    nationalityId: 234,
    idTypeId: 1,
    dateOfIssue: given_date?.value || '',
    placeOfIssue: given_place?.value || '',
    gender: gender,
    dob: dob,
    idNo: id_number,
    name: full_name, // name?.value || '',
  };
  const obj = {
    userAddress,
    userProfile,
    isKYC: isKYC,
    rawImage,
    rule_table,
    decision,
  };
  Log('obj', obj);
  return obj;
};

export const mappingEkycRejectContent = (rule_table: any[]) => {
  let string = 'alert.ekycfail';
  const arr = rule_table?.[0]?.rules || [];
  if (!!arr) {
    const res = arr.find((t: any) => t.rule_code == 'IL-006');
    if (!!res && res.check_result == 2) {
      string = `alert.chungminhhethan`;
    }
  }
  return string;
};
